import React, { useContext, useEffect, useState } from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { MapContext } from "../Context/OptionsApi";
import grph from "./map/icons/bar-chart1.svg";

function Graph({ close }) {
  const { filters, geojsonData } = useContext(MapContext);
  const crop = filters?.crop;
  const infest = filters?.infest;
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!geojsonData?.features || geojsonData.features.length === 0) {
      setChartData([]);
      return;
    }
    const previous = { no: 0, low: 0, med: 0, high: 0 };
    const current = { no: 0, low: 0, med: 0, high: 0 };
    const next = { no: 0, low: 0, med: 0, high: 0 };
    geojsonData.features.forEach(feature => {
      const level = feature.properties?.infest_level;
      if (!level) return;
      const mapLevel = (val) => {
        if (val === 0) return "no";
        if (val === 1) return "low";
        if (val === 2) return "med";
        if (val >= 3) return "high";
        return "no";
      };
      previous[mapLevel(level.previous_week)]++;
      current[mapLevel(level.current_week_forecast)]++;
      next[mapLevel(level.next_week_forecast)]++;
    });
    const data = [
      {
        name: "Previous Week",
        "No Threat": previous.no,
        "Low Probability": previous.low,
        "Medium Probability": previous.med,
        "High Probability": previous.high,
      },
      {
        name: "Current Week",
        "No Threat": current.no,
        "Low Probability": current.low,
        "Medium Probability": current.med,
        "High Probability": current.high,
      },
      {
        name: "Next Week",
        "No Threat": next.no,
        "Low Probability": next.low,
        "Medium Probability": next.med,
        "High Probability": next.high,
      },
    ];
    setChartData(data);
  }, [geojsonData]);

  const renderLegend = (props) => {
    const { payload } = props;
    if (!payload) return null;
    return (
      <ul className="flex justify-center gap-8 mt-6 text-sm font-medium">
        {payload.map((entry, index) => (
          <li key={index} className="flex items-center gap-2">
            <div className="w-4 h-4 rounded" style={{ backgroundColor: entry.color }} />
            <span>{entry.value}</span>
          </li>
        ))}
      </ul>
    );
  };

  if (!chartData.length || chartData.every(d =>
    d["No Threat"] + d["Low Probability"] + d["Medium Probability"] + d["High Probability"] === 0
  )) {
    return (
      <div className="text-center py-20 text-gray-500">
        <p className="text-lg">No infestation data available</p>
        <p className="text-sm mt-2">Try selecting different filters</p>
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={close}
        className="absolute -top-4 -right-4 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:scale-110 transition text-3xl font-light rotate-45 hover:bg-gray-100"
      >
        +
      </button>
      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-gray-800">
          {infest} Infestation Pattern ({crop})
        </h3>
        <p className="text-sm text-gray-600">(Number of Villages)</p>
      </div>
      <ComposedChart width={650} height={400} data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 60 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis dataKey="name" tick={{ fontSize: 14 }} />
        <YAxis
          label={{
            value: "Number of Villages",
            angle: -90,
            position: "insideLeft",
            style: { textAnchor: "middle", fontSize: 14 },
          }}
        />
        <Tooltip />
        <Legend content={renderLegend} />
        <Bar dataKey="No Threat" stackId="a" fill="#8ed49f" barSize={70} />
        <Bar dataKey="Low Probability" stackId="a" fill="#faf748" barSize={70} />
        <Bar dataKey="Medium Probability" stackId="a" fill="#ffba38" barSize={70} />
        <Bar dataKey="High Probability" stackId="a" fill="#eb0505" barSize={70} />
      </ComposedChart>
    </div>
  );
}

export default function GraphModal() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 5,
  };
  return (
    <div>
      <Button onClick={handleOpen}>
        <img src={grph} alt="graph" />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Graph close={handleClose} />
        </Box>
      </Modal>
    </div>
  );
}
